
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { useAuthState } from '../../../../../../Helper/Context';
import { ElEProjectNameDDL } from '../../../../../../Components/CommonDDL/ElEProjectNameDDL';
import { ElEWorkTypeDDL } from '../../../../../../Components/CommonDDL/ElEWorkTypeDDL';
import { WorkSubTypeDDL } from '../../../../../../Components/CommonDDL/WorkSubTypeDDL';
import { WorkNameDDL } from '../../../../../../Components/CommonDDL/WorkNameDDL';
import { ElEProjectWiseWorkNameDDL } from '../../../../../../Components/CommonDDL/ElEProjectWiseWorkNameDDL';
import { PostElEProjectWiseWorkNamePostDataAPI } from '../../../../../../Redux/SidebarMasterSlice/ProjectWiseWorkName';
import { Loading } from '../../../../../../Helper/Loading';
import { ElEWorkSubTypeDDL } from '../../../../../../Components/CommonDDL/ElEWorkSubTypeDDL';
import { ElEWorkNameDDL } from '../../../../../../Components/CommonDDL/ElEWorkNameDDL';


export default function AddElEProjectWiseWorkName(props) {

    const { handleOnCloseClick, open, handleIsPost, Flag, apiFlag, rowData, } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashProjectTypeId = searchParams.get("DashProjectTypeId")

    // const [rowData, setRowData] = useState(rowData)
    const [loading, setloading] = useState(false)

    const [ProjectType, setProjectType] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_ProjectTypeID : 0,
        Label: Flag === 'Update' ? rowData.projectType : "Select...",
    })
    const [ProjectName, setProjectName] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_ProjectID : 0,
        Label: Flag === 'Update' ? rowData.projectName : "Select...",
    })
    const [WorkType, setWorkType] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_WorkTypeID : 0,
        Label: Flag === 'Update' ? rowData.workTypeName : "Select...",
    })
    const [WorkSubType, setWorkSubType] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_WorkSubTypeID : 0,
        Label: Flag === 'Update' ? rowData.workSubTypeName : "Select...",
    })

    const [WorkName, setWorkName] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_WorkID : 0,
        Label: Flag === 'Update' ? rowData.projectWorkname : "Select...",
    })


    const handleClearField = () => {
        if (Flag != 'Update') {
            // setSectorName('')
        }
    }

    const handlePost = () => {
        const data = {
            M_ELEC_ProjectWiseWorkID: rowData?.m_eleC_ProjectWiseWorkID,
            M_ELEC_WorkID: WorkName?.ID,
            M_ProjectID: ProjectName.ID,
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick,
            setloading: setloading,
            Flag: Flag
        }
        dispatch(PostElEProjectWiseWorkNamePostDataAPI({ data }))
    }


    return (

        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="area_pop  modal-dialog modal-xl">
                <div className="modal-content master_border">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Project Wise Work Name</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>

                    {loading && <Loading />}

                    <div className="modal-body ">
                        <div className='inner-modal-body'>

                            <div className="row details-row">

                                <div className="col-12 col-lg-6 ">
                                    <ElEProjectNameDDL
                                        ProjectName={ProjectName}
                                        setProjectName={setProjectName}
                                        M_ProjectTypeID={ProjectTypeId}
                                        rowData={rowData}
                                        Flag={Flag}
                                    />
                                </div>

                                <div className="col-12 col-lg-6 ">
                                    <ElEWorkTypeDDL
                                        WorkType={WorkType}
                                        setWorkType={setWorkType}
                                        IsPost=''
                                        isDisplay={true}
                                        ApiFlag="Master"
                                        rowData={rowData}
                                        Flag={Flag}
                                    />
                                </div>

                                <div className="col-12 col-lg-6 ">
                                    <ElEWorkSubTypeDDL
                                        WorkType={WorkType}
                                        WorkSubType={WorkSubType}
                                        setWorkSubType={setWorkSubType}
                                        IsPost=''
                                        isDisplay={true}
                                        ApiFlag="Master"
                                        rowData={rowData}
                                        Flag={Flag}
                                    />

                                    {/* <WorkSubTypeDDL
                                        WorkSubType={WorkSubType}
                                        setWorkSubType={setWorkSubType}
                                        WorkType={WorkType}
                                        WorkName={WorkName}
                                        setWorkName={setWorkName}
                                        Flag={Flag}
                                        rowData={rowData}
                                        M_ProjectTypeID={ProjectTypeId}
                                    /> */}
                                </div>
                                <div className="col-12 col-lg-6 ">
                                    {/* <WorkNameDDL
                                        WorkName={WorkName}
                                        setWorkName={setWorkName}
                                        WorkType={WorkType}
                                        WorkSubType={WorkSubType}
                                        Flag={Flag}
                                        rowData={rowData}
                                    /> */}
                                    <ElEWorkNameDDL
                                        WorkType={WorkType}
                                        WorkSubType={WorkSubType}
                                        WorkNameType={WorkName}
                                        setWorkNameType={setWorkName}
                                        IsPost=''
                                        isDisplay={true}
                                        ApiFlag="Master"
                                        Flag={Flag}
                                        rowData={rowData}
                                    />

                                    {/* <ElEProjectWiseWorkNameDDL
                                        WorkName={WorkName}
                                        setWorkName={setWorkName}
                                        APIFlag="ProjectWiseWork"
                                        ProjectName={ProjectName}
                                        WorkType={WorkType}
                                        WorkSubType={WorkSubType}
                                        Flag={Flag}
                                        rowData={rowData}
                                    /> */}

                                </div>

                            </div>

                            {/* <div className="mb-4 pt-4">
                                        <div className="float-end">
                                                 <button className="submit_btn"
                                                 disabled={
                                                    ProjectName.ID === 0 && WorkType.ID === 0 && WorkSubType.ID === 0 && WorkName.ID === 0
                                                 }
                                                 onClick={() => (handlePost())
 
                                                 }
                                             >{Flag === "Update" ? "Update" : "Save"} </button>
                                            <span className=" cancel_btn ms-2" onClick={handleOnCloseClick} >Cancel</span>
                                        </div>
                                    </div> */}

                            <div className="col-12 col-lg-12 pt-lg-5">
                                <div className="btn-action d-flex justify-content-end ">

                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => handlePost()}
                                        disabled={
                                            ProjectName.ID == 0 ||
                                            WorkType.ID === 0 ||
                                            // WorkSubType.ID == 0 || 
                                            WorkName.ID == 0
                                        }
                                    >{Flag === "Update" ? "Update" : "Save"} </button>

                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>

            {/* )} */}


        </Popup>
    )

}